import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {GroupModel} from "../../../groups/models/group.model";
import {AgentsPaginationDataModel} from "../../../agents/angular/models/agents-pagination-data.model";
import {AgentsService} from "../../../agents/services/agents-service.service";

export class reportsSisenseTimelineViewComponent implements IController {

  configuration: any;
  branchIds: string[];
  agentIds: string[];
  selectedQuickFilterId?: string;
  groupIds: string[];
  groupsBranchIds: string[];
  page?: number;
  size?: number;
  date?: any;

  private pageName: string;

  public paginationData: AgentsPaginationDataModel;
  public agents: any[];
  public tasks: any[];
  public filtersConfig: any;
  public isStack: boolean;
  private deliveriesRef: any;

  /* @ngInject */
  constructor(private moment,
              private $deliveries,
              private $state,
              private bringozLoaderService: BringozLoaderService,
              private viewFilterSettingsService : ViewFilterSettingsService,
              private agentsService: AgentsService,
              private $groups) {
    this.deliveriesRef = this.$deliveries();
    this.pageName = $state.current.name;
  }

  $onInit() {
    if (!this.size) {
      this.size = 10;
    }
    if (!this.page) {
      this.page = 0;
    }
    this.filtersConfig = {
      queryString: undefined,
      date: this.date || this.moment().valueOf(),
      colorByLate: true,
      bringozFilters: {
        branchIds: this.branchIds || [],
        agentIds: this.agentIds || [],
        [SiteFiltersType.groupIds]: this.groupIds || [],
      },
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.agentIds,
        SiteFiltersType.groupIds,
        SiteFiltersType.groups
      ],
      excludeIdsMap: {
        [SiteFiltersType.branchIds]: this.groupsBranchIds || []
      }
    }
    this.isStack = false;

    this._initAgents();
  }

  onDateChange(date) {
    this.filtersConfig.date = date;
    this._setTasks();
    this._setQueryParams();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      if (quickFilter.settings.groupIds?.length) {
        this.$groups().$asyncValues(quickFilter.settings.groupIds)
          .then((groups) => {
            let groupsBranchIds = [];
            groups.forEach((g: GroupModel) => {
              if (g.branchIds?.length) {
                groupsBranchIds = groupsBranchIds.concat(g.branchIds)
              }
            });
            this.filtersConfig.excludeIdsMap[SiteFiltersType.branchIds] = groupsBranchIds;
            quickFilter.settings[SiteFiltersType.branchIds] = _.uniq(groupsBranchIds);
            this.onFiltersChange(quickFilter.settings, quickFilter);
          })
      } else {
        this.onFiltersChange(quickFilter.settings, quickFilter);
      }    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.filtersConfig.bringozFilters = filters;
    this._initAgents();
    this._setQueryParams();
  }

  onBranchIdsChange(branchIds) {
    if (this.selectedQuickFilterId) {
      this.viewFilterSettingsService.setActiveQuickFilter(undefined, this.pageName);
      this.selectedQuickFilterId = undefined;
    }

    this.filtersConfig.bringozFilters.branchIds = branchIds;
    this.filtersConfig.bringozFilters.agentIds = [];
    this._initAgents();
    this._setQueryParams();
  }

  onAgentsSelectChange(agentIds) {
    if (this.selectedQuickFilterId) {
      this.viewFilterSettingsService.setActiveQuickFilter(undefined, this.pageName);
      this.selectedQuickFilterId = undefined;
    }
    this.filtersConfig.bringozFilters.agentIds = agentIds;
    this._initAgents();
    this._setQueryParams();
  }

  onQueryChange(queryString) {
    this.filtersConfig.queryString = queryString;
  }

  onToggleIsStack() {
    this.isStack = !this.isStack;
  }

  onPaginationChange(page) {
    this.page = page - 1;

    this._setQueryParams();
    this._initAgents();
  }

  onPageSizeChange(size) {
    this.size = size;
    this.page = 0;

    this._setQueryParams();
    this._initAgents();
  }

  private _initAgents() {
    if (!!this.paginationData?.content) {
      this.paginationData.content = undefined;
    }
    this.agentsService.getAgentsPagination(this._getAgentsQuery())
      .then((paginationData: AgentsPaginationDataModel) => {
        this.paginationData = paginationData;

        this._setTasks();
      })
  }

  private _setTasks() {
    this._getServices()
      .then((services) => {
        this.tasks = _.flatMap(services, (s) => {
          const tasksListCopy = angular.copy(s.taskList);

          if (s.packageList) {
            _.forEach(tasksListCopy, (t) => {
              t.packageList = s.packageList;
            })
          }
          return tasksListCopy;
        });
      })
  }

  private _getAgentsQuery() {
    return {
      active: true,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      ids: this.filtersConfig.bringozFilters.agentIds,
      page: this.page, // default 0
      size: this.size, // default 20
    }
  }

  private _setQueryParams() {
    this.$state.go('.', {
      date: this.filtersConfig.date,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      groupIds: this.filtersConfig.bringozFilters.groupIds,
      selectedQuickFilterId: this.selectedQuickFilterId,
      page: this.page,
      size: this.size
    }, {
      notify: false,
      reload: false
    })
  }

  private _getServices() {
    const agentIds = _.map(this.paginationData.content, 'id');

    this.bringozLoaderService.on();
    return this.deliveriesRef.$getAll({
      from: this.moment(this.filtersConfig.date).startOf('day').valueOf(),
      to: this.moment(this.filtersConfig.date).endOf('day').valueOf(),
      // branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentIds: agentIds,
      limit: 1000
      // group: this.group === 'All' ? undefined : this.group,
    })
      .then((ids) => {
        return this.deliveriesRef.$asyncValues(ids);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsSisenseTimelineView', {
    bindings: {
      configuration: '<',
      branchIds: '<?',
      agentIds: '<?',
      selectedQuickFilterId: '<?',
      groupIds: '<?',
      groupsBranchIds: '<?',
      page: '<?',
      size: '<?',
      date: '<?'
    },
    template: require('./reports-sisense-timeline-view.html').default,
    controller: reportsSisenseTimelineViewComponent
  });
